// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/campaign.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ActivateCampaignRequest, ActivateCampaignResponse, AddCampaignCostRequest, AddCampaignCostResponse, ArchiveCampaignRequest, ArchiveCampaignResponse, CloneCampaignRequest, CloneCampaignResponse, CreateCampaignGroupRequest, CreateCampaignGroupResponse, CreateCampaignRequest, CreateCampaignResponse, DeleteCampaignCostRequest, DeleteCampaignCostResponse, DeleteCampaignGroupRequest, DeleteCampaignGroupResponse, DuplicateCampaignRequest, DuplicateCampaignResponse, GetCampaignRequest, GetCampaignResponse, GetDayBoardsRequest, GetDayBoardsResponse, ListCampaignCostsRequest, ListCampaignCostsResponse, ListCampaignGroupsRequest, ListCampaignGroupsResponse, ListCampaignOwnersRequest, ListCampaignOwnersResponse, ListCampaignsRequest, ListCampaignsResponse, ListFreeDomainsRequest, ListFreeDomainsResponse, PauseCampaignRequest, PauseCampaignResponse, PreviewCampaignRulesRequest, PreviewCampaignRulesResponse, RenderAdLinkRequest, RenderAdLinkResponse, UpdateCampaignGroupRequest, UpdateCampaignGroupResponse, UpdateCampaignRequest, UpdateCampaignResponse } from "./campaign_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.CampaignService
 */
export const CampaignService = {
  typeName: "tracker.v1.CampaignService",
  methods: {
    /**
     * @generated from rpc tracker.v1.CampaignService.ListCampaigns
     */
    listCampaigns: {
      name: "ListCampaigns",
      I: ListCampaignsRequest,
      O: ListCampaignsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.GetDayBoards
     */
    getDayBoards: {
      name: "GetDayBoards",
      I: GetDayBoardsRequest,
      O: GetDayBoardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.GetCampaign
     */
    getCampaign: {
      name: "GetCampaign",
      I: GetCampaignRequest,
      O: GetCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.CreateCampaign
     */
    createCampaign: {
      name: "CreateCampaign",
      I: CreateCampaignRequest,
      O: CreateCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.UpdateCampaign
     */
    updateCampaign: {
      name: "UpdateCampaign",
      I: UpdateCampaignRequest,
      O: UpdateCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.PauseCampaign
     */
    pauseCampaign: {
      name: "PauseCampaign",
      I: PauseCampaignRequest,
      O: PauseCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.ActivateCampaign
     */
    activateCampaign: {
      name: "ActivateCampaign",
      I: ActivateCampaignRequest,
      O: ActivateCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.ArchiveCampaign
     */
    archiveCampaign: {
      name: "ArchiveCampaign",
      I: ArchiveCampaignRequest,
      O: ArchiveCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.DuplicateCampaign
     */
    duplicateCampaign: {
      name: "DuplicateCampaign",
      I: DuplicateCampaignRequest,
      O: DuplicateCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.CloneCampaign
     */
    cloneCampaign: {
      name: "CloneCampaign",
      I: CloneCampaignRequest,
      O: CloneCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.RenderAdLink
     */
    renderAdLink: {
      name: "RenderAdLink",
      I: RenderAdLinkRequest,
      O: RenderAdLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.ListFreeDomains
     */
    listFreeDomains: {
      name: "ListFreeDomains",
      I: ListFreeDomainsRequest,
      O: ListFreeDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.ListCampaignGroups
     */
    listCampaignGroups: {
      name: "ListCampaignGroups",
      I: ListCampaignGroupsRequest,
      O: ListCampaignGroupsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * The people who own the workspace's campaigns (the list's «Баер» filter):
     * every owner the caller may see, named, with how many campaigns are theirs.
     *
     * @generated from rpc tracker.v1.CampaignService.ListCampaignOwners
     */
    listCampaignOwners: {
      name: "ListCampaignOwners",
      I: ListCampaignOwnersRequest,
      O: ListCampaignOwnersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.CreateCampaignGroup
     */
    createCampaignGroup: {
      name: "CreateCampaignGroup",
      I: CreateCampaignGroupRequest,
      O: CreateCampaignGroupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.UpdateCampaignGroup
     */
    updateCampaignGroup: {
      name: "UpdateCampaignGroup",
      I: UpdateCampaignGroupRequest,
      O: UpdateCampaignGroupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.DeleteCampaignGroup
     */
    deleteCampaignGroup: {
      name: "DeleteCampaignGroup",
      I: DeleteCampaignGroupRequest,
      O: DeleteCampaignGroupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.ListCampaignCosts
     */
    listCampaignCosts: {
      name: "ListCampaignCosts",
      I: ListCampaignCostsRequest,
      O: ListCampaignCostsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.AddCampaignCost
     */
    addCampaignCost: {
      name: "AddCampaignCost",
      I: AddCampaignCostRequest,
      O: AddCampaignCostResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.CampaignService.DeleteCampaignCost
     */
    deleteCampaignCost: {
      name: "DeleteCampaignCost",
      I: DeleteCampaignCostRequest,
      O: DeleteCampaignCostResponse,
      kind: MethodKind.Unary,
    },
    /**
     * The editor's «12% кликов» beside each buyer rule (boards ERules,
     * ERuleDialog): the campaign's own recent visits replayed through rules
     * that may not be saved yet. Read-only.
     *
     * @generated from rpc tracker.v1.CampaignService.PreviewCampaignRules
     */
    previewCampaignRules: {
      name: "PreviewCampaignRules",
      I: PreviewCampaignRulesRequest,
      O: PreviewCampaignRulesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

